import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {Injectable} from "@angular/core";
import {InsolesProfileModel} from "./insolesProfile.model";
import {LovValueSummaryConverter} from "../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {InsolesProfileSummaryConverter} from "./insolesProfileSummary.converter";
import {InsoleDataSummaryConverter} from "../../../insoles/api/model/data/insoleDataSummary.converter";
import {
    ProviderServiceCoveringConverter
} from "../../../../provider/service/api/entity/converter/providerServiceCovering.converter";
import {
    InsolesProviderModelSummaryConverter
} from "../../../provider/model/api/entity/insolesProviderModelSummary.converter";
import {InsoleDataConverter} from "../../../insoles/api/model/data/insoleData.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesProfileConverter extends HttpModelConverter<InsolesProfileModel> {

    constructor(private lovValueConverter: LovValueSummaryConverter,
                private summaryConverter: InsolesProfileSummaryConverter,
                private insoleDataConverter: InsoleDataConverter,
                private providerServiceCoveringConverter: ProviderServiceCoveringConverter) {
        super();
    }

    protected createInstance(): InsolesProfileModel {
        return new InsolesProfileModel();
    }

    protected enrichObject(result: InsolesProfileModel, src: InsolesProfileModel) {
        result.color = this.lovValueConverter.convert(src.color);
        result.symmetry = this.lovValueConverter.convert(src.symmetry);
        result.symmetrySubType = this.lovValueConverter.convert(src.symmetrySubType);
        result.summary = this.summaryConverter.convert(src.summary);
        result.leftInsoleData = this.insoleDataConverter.convert(src.leftInsoleData);
        result.rightInsoleData = this.insoleDataConverter.convert(src.rightInsoleData);
        result.providerCovering = this.providerServiceCoveringConverter.convert(src.providerCovering);
    }

}